import { callGetExternalApi } from '../utils/externalApiCall';

// @ts-ignore
const baseURL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_BASE_CONTEXT_SII}`;

/**
 * Listado de rutas del backend
 *
 * @return {Object.<string,string>}
 */
const getBackendUrl = (id) => ({
  GET_DOWNLOAD: `${baseURL}/private/complaint/attachment/download/${id}`,
});

/**
 * @returns {Promise<*>}
 */
const getDownload = async (id) => callGetExternalApi({ url: getBackendUrl(id).GET_DOWNLOAD,  responseType: 'blob' });

export default getDownload;
